import React from 'react';
import PropTypes from 'prop-types';
import { frameShape } from 'arts/reducers/work';
import PaperView from './paper_view';
import { calculatePaperProps, calculateFrameThickness } from './utils';

export const renderNoFrame = (paper, zoomPreviewUrl, { imageUrl, title, landscape }) => {
  const {
    paperHeight, paperWidth, printHeight, printWidth
  } = paper;
  const { width, borderH, borderW } = calculatePaperProps({
    paperHeight, paperWidth, printHeight, printWidth, landscape, useWidth: false
  });
  const paperProps = {
    width, borderH, borderW, zoomPreviewUrl
  };
  return (
    <PaperView unframed { ...paperProps }>
      {
        ({ className }) => (
          <img
            src={ imageUrl }
            alt={ title }
            className={ className }
            width="100%"
            height="100%"
          />
        )
      }
    </PaperView>
  );
};

const FrameWithPreview = ({ frame, children, useLandscapeLargeImage }) => {
  const {
    frameWidth, frameHeight, frameMat, frameThickness, zoomPreviewUrl,
    frameLargeImageUrl, landscapeLargeImageUrl,
    mount,
    isTapestry, frameMatColorRgb
  } = frame;
  const [fWidth, fHeight] = useLandscapeLargeImage
    ? [frameHeight, frameWidth]
    : [frameWidth, frameHeight];
  const landscape = useLandscapeLargeImage || fWidth > fHeight;
  const thicknessV = isTapestry && landscape ? 0 : frameThickness;
  const thicknessH = isTapestry && !landscape ? 0 : frameThickness;
  const frameMatW = isTapestry ? 0 : (frameMat + frameThickness) * 2;
  const frameMatH = (frameMat + frameThickness) * 2;
  const { width, borderH, borderW } = calculatePaperProps({
    paperHeight: fHeight + frameMatH,
    paperWidth: fWidth + frameMatW,
    printHeight: fHeight,
    printWidth: fWidth,
    landscape,
    useWidth: true
  });
  const ftH = calculateFrameThickness(
    fWidth + ((thicknessH + frameMat) * 2), 2 * thicknessH
  ) / 2;
  const ftV = calculateFrameThickness(
    fHeight + ((thicknessV + frameMat) * 2), 2 * thicknessV
  ) / 2;
  const backgroundImage = useLandscapeLargeImage ? landscapeLargeImageUrl : frameLargeImageUrl;
  const paperProps = {
    width,
    borderH,
    borderW,
    zoomPreviewUrl,
    backgroundImage,
    frameThicknessH: ftH,
    frameThicknessV: ftV,
    mount,
    isTapestry,
    frameMatColorRgb
  };
  return (
    <PaperView unframed={ false } { ...paperProps }>
      {
        ({ className }) => children({ className, width: fWidth, height: fHeight })
      }
    </PaperView>
  );
};

FrameWithPreview.propTypes = {
  frame: PropTypes.oneOfType([frameShape, PropTypes.object]).isRequired,
  children: PropTypes.func.isRequired,
  useLandscapeLargeImage: PropTypes.bool
};

export default FrameWithPreview;
